import { View, Text } from "react-native";
import { Feather } from "@expo/vector-icons";
import { colors } from "../../../theme";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState, MouseEvent } from "react";
import { Props } from "./types";

export default function EmploymentMenu({ items }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | Element>(null);
  const open = Boolean(anchorEl);

  function onPressOpen(e: MouseEvent) {
    setAnchorEl(e.target as Element);
  }

  function onClose() {
    setAnchorEl(null);
  }

  return (
    <View>
      <IconButton
        data-test-id="employment-menu-anchor"
        sx={{ borderRadius: "4px", backgroundColor: colors.sky.lighter }}
        onClick={onPressOpen}
      >
        <Feather name="more-horizontal" size={24} color={colors.ink.darkest} />
      </IconButton>

      <Menu sx={{ "& .MuiMenu-paper": { borderRadius: "8px" } }} {...{ open, anchorEl, onClose }}>
        {items.map(({ title, icon, onPress }, i) => (
          <MenuItem
            key={i}
            onClick={() => {
              onClose();
              onPress();
            }}
            className="flex-row justify-between items-center"
          >
            <Text className="text-regular-tight text-ink-darkest mr-6">{title}</Text>

            <Feather name={icon} size={24} color={colors.ink.darkest} />
          </MenuItem>
        ))}
      </Menu>
    </View>
  );
}
